import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertService } from '../../../../../core/services/alert.service';
import { AuthGuardService } from '../../../../../core/services/auth/auth-guard.service';
import { I18nService } from '../../../../../core/services/i18n.service';
import { PlatformService } from '../../../../../core/services/platform.service';
import { BaseInputComponent } from '../../../../../shared/components/base-component/base-input.component';
import { AuthModalService } from '../../../../../shared/components/modals/auth-modal/auth-model.service';
import { AuthService } from '../../services/auth.service';
import { SocialAuthService } from '../../services/social-auth.service';
import { DocumentService } from '../../../../../core/services/document.service';
import { SharedModule } from '../../../../../shared/shared-module';
import { TranslateService } from '../../../../../shared/modules/translate/translate.service';

@Component({
  selector: 'app-openid-authentication',
  templateUrl: './openid-authentication.component.html',
  styleUrl: './openid-authentication.component.scss',
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class OpenidAuthenticationComponent
  extends BaseInputComponent
  implements OnInit {
  returnUrl?: string;
  constructor(
    private alert: AlertService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    public socialAuthService: SocialAuthService,
    private pt: PlatformService,
    private authGuardService: AuthGuardService,
    public authModalService: AuthModalService,
    // private i18nService: I18nService,
    private translationService: TranslateService,
    private documentService: DocumentService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.pt.isServer) return;
    this.returnUrl =
      this.route.snapshot.queryParams['returnUrl'.toString()] || '/';

    this.signInByGoogle();

    this.socialAuthService.initGoogleSDK();
  }

  async signInByGoogle() {
    this._(
      this.socialAuthService.googleOnSignedIn.subscribe(
        async (account: any) => {
          if (!account) return;
          this.login(account.credential);
        },
      ),
    );
  }

  async login(credential: string) {
    const res = await this.authService.logInByGoogle(credential);
    this.authGuardService.setUserToken(res.result, this.authModalService.isInModal);
    this.alert.suucess('Logged In Successfully');
    if (this.authModalService.isInModal) {
      this.authModalService.close();
      return;
    }

    // this.i18nService.setLanguage(res.result.user.languageCode);
    // this.translationService.setLanguage(res.result.user.languageCode);

    if (this.returnUrl) {
      if (this.returnUrl.includes('http'))
        this.documentService.location.href = this.returnUrl;
      else this.router.navigateByUrl(this.returnUrl);
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
